import React, { useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "./TextField.module.scss";

const TextField = ({
  rootClass,
  className,
  backColor,
  textColor,
  label,
  error,
  value,
  autoFocus,
  disabled,
  helperText,
  multiline,
  rows,
  ...rest
}) => {
  const [focus, setFocus] = useState(autoFocus);
  const [hover, setHover] = useState(false);
  const isShowPlaceholder = !!label && !focus;

  const renderField = () => {
    if (multiline) {
      return (
        <textarea
          data-focus={autoFocus}
          className={classNames(styles["field-input"], className)}
          style={textColor ? { color: textColor } : null}
          rows={rows}
          value={value}
          disabled={disabled}
          {...rest}
        />
      );
    }

    return (
      <input
        data-focus={autoFocus}
        className={classNames(styles["field-input"], className)}
        style={textColor ? { color: textColor } : null}
        value={value}
        disabled={disabled}
        {...rest}
      />
    );
  };

  return (
    <div
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={classNames(styles["field-root"], styles[rootClass], {
        [styles["disabled"]]: disabled,
        [styles["focus"]]: focus,
        [styles["active"]]: value.length,
        [styles["error"]]: error && !(hover || focus),
        [styles["hover"]]: hover && !disabled,
        [styles["multiline"]]: multiline,
        [styles["with-label"]]: !!label,
      })}
      style={backColor ? { backgroundColor: backColor } : null}>
      {!!label && (
        <label className={styles["field-label"]} data-label={isShowPlaceholder}>
          {label}
        </label>
      )}
      <div className={styles["field-container"]}>
        {renderField()}
        <fieldset className={styles["field-fieldset"]}>
          <legend>
            <span>{label}</span>
          </legend>
        </fieldset>
      </div>
      {!!helperText && <p className={styles["field-helper"]}>{helperText}</p>}
    </div>
  );
};

TextField.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  rootClass: PropTypes.string,
  backColor: PropTypes.string,
  textColor: PropTypes.string,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  error: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
};

export default TextField;
